// extracted by mini-css-extract-plugin
export default {"legalContainer":"LegalPage_legalContainer__OwykG","sectionTitle":"LegalPage_sectionTitle__FN3uk"};